import React from "react";
import { tech } from "../techIcons";

// Infinite scrolling strip of the technologies used; list is doubled for a seamless loop.
function Marquee({ reverse = false, items = tech }) {
  const row = [...items, ...items];
  return (
    <div className={`marquee ${reverse ? "reverse" : ""}`} aria-hidden="true">
      <div className="marquee-track">
        {row.map(({ name, Icon, color }, i) => (
          <span key={name + i} className="marquee-item" style={{ "--c": color }}>
            <Icon /> {name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
